import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import * as AppActions from "../../redux/actions/app.actions";
import * as EventActions from "../../redux/actions/event.actions";
import Dropdown from "@sellout/ui/build/components/Dropdown";
import { BackstageState } from "../../redux/store";
import { useLazyQuery } from "@apollo/client";
import GET_SEASON from "@sellout/models/.dist/graphql/queries/season.query";
import { AppNotificationTypeEnum } from "../../models/interfaces/IAppNotification";
import { NEW_EVENT_ID } from "../../redux/reducers/event.reducer";
import useListSeasonsDropdownHook from "../../hooks/useListSeasonDropdown.hook";

const Container = styled.div`
  position: relative;
`;

type CreateEventAddSeasonProps = {};

const CreateEventAddSeason: React.FC<CreateEventAddSeasonProps> = ({}) => {
  /* Hooks */
    const { seasons } = useListSeasonsDropdownHook();
  const eventState = useSelector((state: BackstageState) => state.event);
  const { eventId, eventsCache } = eventState;
  const event = eventsCache[eventId];

  let seasonValidationErrors = "" as string;

  const season: any = seasons?.filter((a) => a._id === event?.seasonId);
  
  const [seasonName, setSeasonName] = useState(season && season[0]?.name);
  const [onEditseasonName, setOnEditseasonName] = useState<any>("");
  /* Actions */
  
  const dispatch = useDispatch();

  const publishedSeasons = seasons?.filter((a) => a.published);

  const [getSeason, { data }] = useLazyQuery(GET_SEASON, {
    onCompleted: (data) => {
      setSeasonName(season[0]?.name as string);
      if (
        (event?.performances?.[0].schedule?.[0].startsAt as number) >=
          (data?.season?.schedule?.startsAt as number) ||
        (event?.performances?.[0].schedule?.[0].startsAt as number) <=
          (data?.season?.schedule?.endsAt as number) ||
        (event?.performances?.[0].schedule?.[0].endsAt as number) <=
          (data?.season?.schedule?.endsAt as number)
      ) {
        dispatch(EventActions.setEventAddSeason(eventId, data?.season?._id));
        const season: any = seasons?.filter((a) => a._id === data?.season?._id);
        
      } else {
        seasonValidationErrors =
          '"Event" should be in between start date to end date of this selected season.';
        dispatch(
          AppActions.showNotification(
            seasonValidationErrors,
            AppNotificationTypeEnum.Error
          )
        );
      }
      dispatch(EventActions.setEventVenueId(eventId, data?.season?.venueId));
      dispatch(
        EventActions.selectEventSeatingChart(
          eventId,
          data?.season?.seatingChartKey
        )
      );
    },
  });

  const setEventSeasonId = (seasonId: string) => {
    getSeason({
      variables: { seasonId: seasonId },
    });
  };

  /** Render */
  const items =
  publishedSeasons &&
  publishedSeasons.map((season) => {
      return {
        text: season.name,
        value: season._id
      };
    
  });
  useEffect(() => {
    if (event._id ==NEW_EVENT_ID) {
      setOnEditseasonName("")
    }
    if (event && event?.seasonId) {
      const selectedSeason = seasons?.find(season => season?._id === event.seasonId);
      if (selectedSeason) {
        setOnEditseasonName(selectedSeason.name);
      }
    }
  }, [event, seasons]);
  return (
    <Container>
      <Dropdown
        value={onEditseasonName || "Select a season" }
        items={items as any}
        onChange={(seasonId: string) => {
          setEventSeasonId(seasonId);
        }}
        label="Season"
      />
    </Container>
  );
};

export default CreateEventAddSeason;
